import React from 'react';

import { LESSON_INFORMATION_BANNER_VIEW } from 'common.components/lesson-view.information-banner/information-banner';

import './information-banners.scss';

export interface InformationBanner<T> {
    element: React.ReactElement;
    type: T;
}

type PriorityMap<T extends PropertyKey> = { [key in T]: number };

interface Props<T extends PropertyKey> {
    banners: Array<InformationBanner<T>>;
    priorityMap: PriorityMap<T>;
    mix?: string;
}

const getBannersComparator = <T extends PropertyKey>(priorityMap: PriorityMap<T>) => {
    return ({ type: typeA }: InformationBanner<T>, { type: typeB }: InformationBanner<T>) =>
        priorityMap[typeA] - priorityMap[typeB];
};

export const InformationBanners = <T extends PropertyKey>(props: Props<T>) => {
    const { banners, mix, priorityMap } = props;

    if (banners.length === 0) {
        return null;
    }

    banners.sort(getBannersComparator(priorityMap));

    return (
        <div className={mix}>
            {banners.map(({ element }, index) => {
                if (index === 0) {
                    return React.cloneElement(element, { view: LESSON_INFORMATION_BANNER_VIEW.ACTION });
                }

                return element;
            })}
        </div>
    );
};
